module.exports = __webpack_public_path__ + "media/packs/images/search/containers-0b9fd78836f906b5e4b5d3c814b57e81.svg";